import React, { useContext } from 'react';
import style from './Description.module.scss';
import { AppContext } from '../../context/AppContext';


const Description = () => {
  const contextData = useContext(AppContext);
  const { sport } = contextData || {};
  const description = sport ? window.descriptions?.[sport] : "";

  if(!description) return <></>;

  return (
    <div className={style.description__wrapper}>
      <div className={style.description} dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  );
};

export default Description;
